/**
 * Light/dark toggle.
 *
 * The template uses the `theme-change` CDN script. Same behaviour — flip
 * `data-theme` on `<html>` and remember it — in eight lines and no network
 * request.
 *
 * Renders a bare `swap` label, intended to sit inside a daisyUI menu `li` (see
 * `AppShell`), which is what gives it the navbar's shared hover and focus
 * styling. It deliberately carries **no `btn` class**: daisyUI's menu-hover
 * selector ends in `:not(.menu-active, :active, .btn)`, so adding one would
 * silently swap the menu hover for the ghost button's near-invisible tint.
 */
import { useEffect, useState } from 'react';
import { Icon } from './Icon';

const STORAGE_KEY = 'picklii-theme';

export function ThemeToggle() {
	const [theme, setTheme] = useState<'light' | 'dark'>(
		() => (localStorage.getItem(STORAGE_KEY) as 'light' | 'dark' | null) ?? 'dark',
	);

	useEffect(() => {
		document.documentElement.dataset.theme = theme;
		localStorage.setItem(STORAGE_KEY, theme);
	}, [theme]);

	return (
		<label className="swap swap-rotate" aria-label="Toggle theme">
			<input
				type="checkbox"
				checked={theme === 'light'}
				onChange={(e) => setTheme(e.target.checked ? 'light' : 'dark')}
				aria-label="Toggle theme"
			/>
			<Icon name="sun" className="swap-on size-4" />
			<Icon name="moon" className="swap-off size-4" />
		</label>
	);
}
